export const iconFontAwesomeEmojiFaceGrinTongue = (
	<i className="fa-solid fa-face-grin-tongue"></i>
);
